import analytics from "../analytics/index.mjs";
function trackStoreReviewRequest(payload) {
  analytics.pushEvent("NativeRateAppView", payload);
}
function trackNotificationRegistration(payload) {
  analytics.pushEvent("NativeSubscribePushPrompt", payload);
}
function trackNotificationRegistrationSuccess(payload) {
  analytics.pushEvent("NativeSubscribePushPromptSuccess", payload);
}
function trackNotificationRegistrationFailure(error, payload) {
  analytics.pushError("NativeSubscribePushPromptFailure", error, payload);
}
function trackTrackingAuthorizationRequest() {
  analytics.pushEvent("NativeAdTrackingPrompt");
}
function trackTrackingAuthorizationRequestSuccess() {
  analytics.pushEvent("NativeAdTrackingPromptSuccess");
}
function trackTrackingAuthorizationRequestFailure(error) {
  analytics.pushError("NativeAdTrackingPromptFailure", error);
}
export {
  trackNotificationRegistration,
  trackNotificationRegistrationFailure,
  trackNotificationRegistrationSuccess,
  trackStoreReviewRequest,
  trackTrackingAuthorizationRequest,
  trackTrackingAuthorizationRequestFailure,
  trackTrackingAuthorizationRequestSuccess
};
